import React, { useState } from 'react'

import Heart from '../../Assets/Images/logo1.png'
import Strategic from '../../Assets/Images/logo3.png'
import Mind from '../../Assets/Images/mind-pause.png'
import Soul from '../../Assets/Images/soul-pause.png'
import Strength from '../../Assets/Images/strength-pause.png'
import Performance from '../../Assets/Images/perform-pause.png'
import Visionary from '../../Assets/Images/vision-pause.png'
import Collaborative from '../../Assets/Images/collab-pause.png'
import useWindowDimensions from '../../Hooks/useWindowDimensions'

const PauseScreen = ({ starterMost, leadershipMost, style, pageId, hasLeader, member, leader, selfUserName, userName }) => {

  // console.log("starterMost", starterMost)
  // console.log("leadershipMost", leadershipMost)
  const { windowWidth } = useWindowDimensions();
  console.log("selfusername", selfUserName)

  const starterLabels = ['Heart Starter', 'Soul Starter', 'Mind Starter', 'Strength Starter'];
  const leadershipLabels = ['Performance', 'Strategic', 'Visionary', 'Collaborative'];

  const capitalizeFirstLetter = (string) => {
    if (!string) return "";
    if (string === string.toUpperCase()) return string;
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
  };

  const first_name = member ? member.split(" ")[0] : selfUserName ? selfUserName.split(" ")[0] : userName ? userName.split(" ")[0] : "";

  const displayName = capitalizeFirstLetter(first_name);


  const highestStarterIndex = starterMost.indexOf(Math.max(...starterMost));
  const starterType = starterLabels[highestStarterIndex];

  const highestLeadershipIndex = leadershipMost.indexOf(Math.max(...leadershipMost));
  const leadershipType = leadershipLabels[highestLeadershipIndex];

  // console.log("leadershipType-first_name", leadershipType,first_name,member)


  console.log('hasLeader', hasLeader)
  console.log('leader', leader)

  const getText = () => {
    if (pageId == 947) {
      return <p className='pausescreen-text'>Up ahead, let's dive into {hasLeader ? "the participant's" : "discovering your"} Leadership Style.</p>
    } else {
      return hasLeader ? <p className='pausescreen-text'>Next, we'll explore how the participant approaches growth and adaptability.</p> : <p className='pausescreen-text'>Next, we’ll explore whether your mindset is growth-oriented or stays fixed.</p>
    }
  }

  const getImage = () => {
    if (hasLeader === false) {

      if (pageId == 947) {
        if (starterType === "Soul Starter") {
          return <img src={Soul} alt='' />
        } else if (starterType === "Mind Starter") {
          return <img src={Mind} alt='' />
        } else if (starterType === "Strength Starter") {
          return <img src={Strength} alt='' />
        } else
          return <img src={Heart} alt='' />
      }
      else {
        if (leadershipType === "Performance") {
          return <img src={Performance} alt='' />
        } else if (leadershipType === "Visionary") {
          return <img src={Visionary} alt='' />
        } else if (leadershipType === "Collaborative") {
          return <img src={Collaborative} alt='' />
        } else
          return <img src={Strategic} alt='' />
      }
    }
  }

  const maxWidthfunction = () => {
    if(windowWidth > 830) return '60ch'
    if(pageId == 947) return '24ch'
    return '28ch'
  }

  return (
    <div className='pause-container'>

      {getImage()}

      {hasLeader ?
        <>
          {/* <h1> {pageId == 947 ?  `${first_name}, you are a ${starterType}!` : `${first_name}, your leadership style is ${leadershipType}`}</h1>
          <p>Discover deeper insights at the end of this assessment.</p> */}
          <h1> {pageId == 947 ? `${displayName}, thank you for your thoughtful input!` : `${displayName}, thank you for your valuable insights!`}</h1>
          {getText()}
        </>
        :
        <>
          <h1 className='oberser' style={{ maxWidth: maxWidthfunction() }}> {displayName ? displayName + ", you" : 'You'} {pageId == 947 ? (<>{' '} show up as a {windowWidth < 600 && <br />} {starterType}!</>) : (<>{' '} reflect a {leadershipType} Leadership style!</>)}</h1>
          <p className='pausescreen-text'>Discover deeper insights at the end of this assessment.</p>
          {getText()}
        </>
      }

    </div>
  )
}

export default PauseScreen